/* One person's page. Tokens only (ADR-0007). */

.main {
  grid-column: 1 / 9;
  min-width: 0;
}

.side {
  grid-column: 9 / 13;
  min-width: 0;
}

@media (width <= 900px) {
  .main,
  .side {
    grid-column: 1;
  }
}

.kv {
  grid-template-columns: 130px minmax(0, 1fr);
}

.can {
  display: block;
  margin-top: 2px;
  font-size: var(--t-min);
  line-height: 1.45;
  color: var(--ink-2);
}

.you {
  display: inline-block;
  margin-left: 8px;
  padding: 1px 6px;
  border: 1px solid var(--accent-line);
  border-radius: 999px;
  background: var(--accent-w);
  font-size: var(--t-min);
  font-weight: 600;
  color: var(--accent);
}

.you::first-letter {
  text-transform: uppercase;
}

.mono {
  font-family: var(--mono);
  font-size: var(--t-min);
  color: var(--ink-2);
  overflow-wrap: anywhere;
}

.warn {
  margin: 0 0 8px;
  font-size: var(--t-min);
  line-height: 1.45;
  color: var(--warn);
}

.filings {
  margin: 0 0 8px;
  padding-left: 18px;
  font-size: var(--t-min);
  color: var(--ink-2);
}

.factor {
  display: flex;
  gap: 8px;
  align-items: baseline;
  flex-wrap: wrap;
  margin: 0 0 8px;
  font-size: var(--t-min);
  color: var(--ink-2);
}

.rows {
  list-style: none;
  margin: 0 0 8px;
  padding: 0;
  display: grid;
  gap: 6px;
}

.rowItem {
  display: flex;
  gap: 10px;
  align-items: baseline;
  flex-wrap: wrap;
}

.rowMeta {
  margin-left: auto;
  font-size: var(--t-min);
  color: var(--muted);
}

.sumLine {
  margin: 8px 0 0;
  font-size: var(--t-min);
  color: var(--ink-2);
}
